"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OriflameLogoSvg = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const OriflameLogoSvg = exports.OriflameLogoSvg = (0, _mui.styled)('svg')(({
  theme
}) => ({
  width: 90,
  transition: `width ${_presentationUtils.CSS_HEIGHT_ANIMATION}`,
  [theme.breakpoints.up('md')]: {
    width: 118
  }
}));